import { amplitudeEventsLib } from '../amplitude-events';
import { googleAnalyticsEventsLib } from '../google-analytics-events';

export const aviaTourPromoOfferShown = () => {
  googleAnalyticsEventsLib.aviaTourPromoOfferShown();
  amplitudeEventsLib.aviaTourPromoOfferShown();
};

export const aviaTourPromoOfferClicked = () => {
  googleAnalyticsEventsLib.aviaTourPromoOfferClicked();
  amplitudeEventsLib.aviaTourPromoOfferClicked();
};
